import { render, staticRenderFns } from "./inpatientDeposit.vue?vue&type=template&id=d5e05640&scoped=true"
import script from "./inpatientDeposit.vue?vue&type=script&lang=js"
export * from "./inpatientDeposit.vue?vue&type=script&lang=js"
import style0 from "./inpatientDeposit.vue?vue&type=style&index=0&id=d5e05640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e05640",
  null
  
)

export default component.exports